var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuestionBankGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#475B7F",
    d: "M7 10v7.765h10V10h1.25v7.765h1.563c.517 0 .937.474.937 1.059v1.764h.625c.345 0 .625.316.625.706v.353c0 .195-.14.353-.313.353H2.313C2.14 22 2 21.842 2 21.647v-.353c0-.39.28-.706.625-.706h.625v-1.764c0-.585.42-1.06.938-1.06H5.75V10H7zm4.407-7.892a1.682 1.682 0 011.186 0l9.105 4.442a.526.526 0 01.302.49v.385c0 .29-.21.525-.469.525h-.781v.525c0 .29-.21.525-.469.525H3.72c-.26 0-.469-.235-.469-.525V7.95H2.47c-.26 0-.469-.235-.469-.525v-.384c0-.218.12-.414.302-.491z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F9BB3",
    d: "M11.85 15.1a.85.85 0 01.099 1.694l-.099.006-.099-.006a.851.851 0 01-.631-1.278l.013-.021a.849.849 0 01.717-.395zm.04-5.1c1.137 0 2.35.91 2.35 2.11 0 1.523-1.574 1.62-1.707 2.14l-.01.074v.028l-.008.066a.244.244 0 01-.169.173l-.064.009-.966-.019-.064-.008a.25.25 0 01-.17-.174l-.008-.066v-.083l.008-.163c.064-.626.376-.813.777-1.052l.326-.189c.33-.195.662-.519.662-.794 0-.487-.53-.794-1.073-.794-.549 0-.847.325-1.207.794a.245.245 0 01-.1.076l-.059.016h-.061a.267.267 0 01-.06-.016l-.056-.032-.635-.441-.045-.045a.252.252 0 01-.01-.291c.55-.844 1.251-1.319 2.35-1.319z"
  }))));
}

export default SvgQuestionBankGray;